import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { hasItems } from 'src/utils/hasItems';

import { RouteHandlerReturn } from 'src/types/model';

import Placeholders from 'components/BaseHelpers/Placeholders';

import styles from './DefaultTemplate.module.scss';

export type DefaultTemplateProps = {
  routeData: RouteHandlerReturn;
};

const DefaultTemplate = ({ routeData }: DefaultTemplateProps): JSX.Element => {
  const content = routeData.props?.route?.placeholders?.content || [];
  const header = routeData.props?.route?.placeholders?.header || [];
  const footer = routeData.props?.route?.placeholders?.footer || [];

  const router = useRouter();

  useEffect(() => {
    const asPath = router.asPath;

    // This is per: https://onenorthi.atlassian.net/browse/AM-15062
    // Run only on bio pages like `/people/[slug]`
    const isProfBioPage = asPath.startsWith('/people/') && asPath !== '/people';

    if (isProfBioPage) {
      const handleLinkClick = (link: HTMLAnchorElement) => () => {
        const phoneType = link.getAttribute('data-phone-type') || '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'contact_click',
          phone_type: phoneType,
          link_text: link.textContent?.trim() || '',
          content_type: 'contact_detail',
          content_title: document.title,
          location_name: '', // no way to pull this in dynamically at the moment so leaving blank
          bio_name: document.querySelector('h2')?.textContent?.trim() || '',
        });
      };

      const contactLinks = document.querySelectorAll('a[href^="tel:"], a[href^="mailto:"]');
      contactLinks.forEach((link: HTMLAnchorElement) => {
        link.addEventListener('click', handleLinkClick(link));
      });

      return () => {
        contactLinks.forEach((link: HTMLAnchorElement) => {
          link.removeEventListener('click', handleLinkClick(link));
        });
      };
    }
    return;
  }, [router.asPath]);

  return (
    <div className={styles.main}>
      {hasItems(header) && <Placeholders placeholders={header} />}
      {hasItems(content) && (
        <main id="main" className={styles.placeholders}>
          <Placeholders placeholders={content} />
        </main>
      )}
      {hasItems(footer) && <Placeholders placeholders={footer} />}
    </div>
  );
};
export default DefaultTemplate;
